(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dga-directors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('digitek-director-cards')) {
    customElements.define(
      'digitek-director-cards',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.addEventListener('click', event => {
            const opener = event.target.closest('[data-director-open]');

            if (opener && this.contains(opener)) {
              const dialog = document.getElementById(
                opener.dataset.directorOpen
              );

              if (dialog && !dialog.open) dialog.showModal();
              return;
            }

            const close = event.target.closest('[data-director-close]');
            if (close) close.closest('dialog').close();
          });

          this.querySelectorAll('dialog').forEach(dialog => {
            dialog.addEventListener('click', event => {
              if (event.target !== dialog) return;

              const rect = dialog.getBoundingClientRect();
              const outside =
                event.clientX < rect.left ||
                event.clientX > rect.right ||
                event.clientY < rect.top ||
                event.clientY > rect.bottom;

              if (outside) dialog.close();
            });
          });
        }

        disconnectedCallback() {
          this.querySelectorAll('dialog[open]').forEach(dialog => {
            dialog.close();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dga-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('digitek-about-timeline-v2')) {
  customElements.define('digitek-about-timeline-v2', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        if (!this.isConnected || this.initialized) return;
        this.track = this.querySelector('.dga-slides');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.years = [...this.querySelectorAll('[data-year]')];
        if (!this.track || !this.slides.length || (this.slides.length > 1 && this.years.length !== this.slides.length)) {
          if (!this.observer) {
            this.observer = new MutationObserver(this.schedule);
            this.observer.observe(this, { childList: true, subtree: true });
          }
          return;
        }
        this.observer?.disconnect();
        this.observer = null;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.slides.forEach(slide => { slide.hidden = false; });
        this.activate(0);
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-year')) this.show(Number(button.dataset.year));
          else if (button.hasAttribute('data-prev')) this.show(this.index - 1);
          else if (button.hasAttribute('data-next')) this.show(this.index + 1);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const edge = this.track.getBoundingClientRect().left + this.track.clientLeft;
            let closest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, i) => {
              const delta = Math.abs(slide.getBoundingClientRect().left - edge);
              if (delta < distance) { distance = delta; closest = i; }
            });
            this.activate(closest);
          });
        }, { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.slide));
        }, { signal });
      };
      this.ready = () => requestAnimationFrame(this.schedule);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true });
      else this.ready();
    }
    activate(index) {
      this.index = index;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      this.years.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    show(index) {
      if (!this.initialized || !this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      const edge = this.track.getBoundingClientRect().left + this.track.clientLeft;
      const left = this.track.scrollLeft + this.slides[next].getBoundingClientRect().left - edge;
      this.track.scrollTo({ left, behavior: 'instant' });
      this.activate(next);
      const button = this.years[next];
      if (button) {
        const rail = button.parentElement;
        rail.scrollTo({ left: rail.scrollLeft + button.getBoundingClientRect().left - rail.getBoundingClientRect().left - (rail.clientWidth - button.clientWidth) / 2, behavior: 'instant' });
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.ready);
      this.observer?.disconnect();
      this.observer = null;
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.initialized = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('.dft-footer').forEach((footer) => {
        if (footer.dataset.accordionsReady) return;
        footer.dataset.accordionsReady = 'true';
        const media = window.matchMedia('(min-width: 768px)');
        const menus = footer.querySelectorAll('[data-dft-menu]');
        const update = () =>
          menus.forEach((menu) => {
            menu.open = media.matches;
          });
        update();
        const controller = new AbortController();
        media.addEventListener('change', update, { signal: controller.signal });
        menus.forEach((menu) =>
          menu.querySelector(':scope > summary').addEventListener('click', (event) => {
            if (media.matches) event.preventDefault();
          })
        );
        document.addEventListener(
          'shopify:section:unload',
          (event) => {
            if (event.target.contains(footer)) controller.abort();
          },
          { signal: controller.signal }
        );
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
